import { useLocation } from 'react-router-dom';

import { EntityListProvider } from '@backstage/plugin-catalog-react';

import { DaaSContent } from './DaaSContent';

const TITLE = 'Deployment as a Service';
const INITIAL_KIND = 'component';

export const DaaSExplorerPage = () => {
  const location = useLocation();

  return (
    <EntityListProvider key={location.key}>
      <DaaSContent initialKindFilter={INITIAL_KIND} title={TITLE} />
    </EntityListProvider>
  );
};
